/**
*
* RedSpeakersSpeaker
*
*/

import React from 'react';
import PropTypes from 'prop-types';


import authorImg from 'components/Templates/globalAssets/speakers/speakerblank.jpg';

import Wrapper from 'components/Templates/dynamics/Wrapper';


class RedSpeakersSpeaker extends React.PureComponent {

  render() {


    const {
      commonData,
      openEditor,
      commonProps,
      thisSpeaker,
      speakerCompany,
      companyLogoType,
      hideDetails,
      hideLogo,
      hidePosition,
      isSingle,
      speakersLength,
      showDetails
    } = this.props;

    const {
      baseUrlTamplate
    } = commonProps;

    const thisCompanyLogoType = companyLogoType ? companyLogoType : 'colorLogo';

    const speakerIcons = thisSpeaker ? (
      <Wrapper
        {...commonProps}
        content={thisSpeaker}
        typeOfStyle={'speakerIcons'}
        
        editorData={
          {
            editorType: 'speakerIcons',
            ...commonData
          }
        }
      >

        {
          thisSpeaker.linkedin ? (
            <Wrapper
              {...commonProps}
              content={thisSpeaker}
              typeOfStyle={'speakerLinkedinIcon'}
              href={thisSpeaker.linkedin.startsWith('http') ? thisSpeaker.linkedin : `https://${thisSpeaker.linkedin}`}
              
              target={'_blank'}
              editorData={
                {
                  editorType: 'speakerLinkedinIcon',
                  ...commonData
                }
              }
            />
          ) : ''
        }

        {
          thisSpeaker.facebook ? (
            <Wrapper
              {...commonProps}
              content={thisSpeaker}
              typeOfStyle={'speakerFacebookIcon'}
              href={thisSpeaker.facebook.startsWith('http') ? thisSpeaker.facebook : `https://${thisSpeaker.facebook}`}
              
              target={'_blank'}
              editorData={
                {
                  editorType: 'speakerFacebookIcon',
                  ...commonData
                }
              }
            />
          ) : ''
        }

        {
          thisSpeaker.instagram ? (
            <Wrapper
              {...commonProps}
              content={thisSpeaker}
              typeOfStyle={'speakerInstagramIcon'}
              href={thisSpeaker.instagram.startsWith('http') ? thisSpeaker.instagram : `https://${thisSpeaker.instagram}`}
              
              target={'_blank'}
              editorData={
                {
                  editorType: 'speakerInstagramIcon',
                  ...commonData
                }
              }
            />
          ) : ''
        }

        {
          thisSpeaker.twitter ? (
            <Wrapper
              {...commonProps}
              content={thisSpeaker}
              typeOfStyle={'speakerTwitterIcon'}
              href={thisSpeaker.twitter.startsWith('http') ? thisSpeaker.twitter : `https://${thisSpeaker.twitter}`}
              
              target={'_blank'}
              editorData={
                {
                  editorType: 'speakerTwitterIcon',
                  ...commonData
                }
              }
            />
          ) : ''
        }
        {
          thisSpeaker.website ? (
            <Wrapper
              {...commonProps}
              content={thisSpeaker}
              typeOfStyle={'speakerWWWIcon'}
              href={thisSpeaker && thisSpeaker.website.startsWith('http') ? thisSpeaker.website : `https://${thisSpeaker.website}`}
              
              target={'_blank'}
              editorData={
                {
                  editorType: 'speakerWWWIcon',
                  ...commonData
                }
              }
            />
          ) : ''
        }

      </Wrapper>
    ) : '';

    const thisBaseTemplateUrl = baseUrlTamplate ? baseUrlTamplate : '';

    const details = hideDetails || !isSingle && speakersLength > 6  ? '' : (
      <>
      {
        thisCompanyLogoType && speakerCompany && speakerCompany[thisCompanyLogoType] && !hideLogo ? (
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'speakerLogoContainer'}
            editorData={
              {
                editorType: 'speakerLogoContainer',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'speakerLogo'}
              backgroundImage={speakerCompany[thisCompanyLogoType]}
              editorData={
                {
                  editorType: 'speakerLogo',
                  ...commonData
                }
              }
            />
          </Wrapper>
        ) : ''
      }

        <Wrapper
          {...commonProps}
          
          typeOfStyle={'speakerName'}
          href={thisBaseTemplateUrl+'/speaker/'+thisSpeaker.slug}
          editorData={
            {
              editorType: 'speakerName',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            content={thisSpeaker}
            typeOfStyle={'firstName'}
            
            editorData={
              {
                editorType: 'firstName',
                ...commonData
              }
            }
          />
          {' '}
          <Wrapper
            {...commonProps}
            content={thisSpeaker}
            
            typeOfStyle={'lastName'}
            editorData={
              {
                editorType: 'lastName',
                ...commonData
              }
            }
          />
        </Wrapper>
 
      {
        speakersLength < 2 || isSingle || showDetails ? (
          <>
            <Wrapper
              {...commonProps}
              typeOfStyle={'speakerJob'}
              
              editorData={
                {
                  editorType: 'speakerJob',
                  ...commonData
                }
              }
            >
              {thisSpeaker.position && !hidePosition ? thisSpeaker.position : ''}        
            </Wrapper>
            <Wrapper
              {...commonProps}
              typeOfStyle={'speakerComapny'}
              
              editorData={
                {
                  editorType: 'speakerComapny',
                  ...commonData
                }
              }
            >
              {speakerCompany ? speakerCompany.name : ''}
            </Wrapper>
          </>
        ) : ''
      }


      {
        thisSpeaker.description ? (
          <Wrapper
            {...commonProps}
            content={thisSpeaker}
            typeOfStyle={'speakerDescription'}
            
            editorData={
              {
                editorType: 'speakerDescription',
                ...commonData
              }
            }
          />
        ) : ''
      }
      {speakerIcons}
      </>
    );

    return (
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'speakerContainer'}        
        customStyleWrapper={
          speakersLength < 2 || speakersLength && speakersLength < 2 ? {
            'flex-basis': '100%'
          } : showDetails ? {
            'flex-basis': '50%'
          } : {}
        }
        editorData={
          {
            editorType: 'speakerContainer',
            ...commonData
          }
        }
        key={`RedSpeakers-speakerContainer-${thisSpeaker.speakerId}`}
      >
        <Wrapper
          {...commonProps}
          
           typeOfStyle={'speakerAvatar'}
          backgroundImage={thisSpeaker.avatar ? thisSpeaker.avatar : authorImg}
          href={thisBaseTemplateUrl+'/speaker/'+thisSpeaker.slug}
          editorData={
            {
              editorType: 'speakerAvatar',
              ...commonData
            }
          }
        >
        </Wrapper>
        {details}
      </Wrapper>
    );


  }
}

RedSpeakersSpeaker.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  speakers: PropTypes.array,
  setShowPopup: PropTypes.func,
  defaultValues: PropTypes.object,
  thisSpeaker: PropTypes.object,
  speakerCompany: PropTypes.object,
};

export default RedSpeakersSpeaker;
